import ImageZoom, { ImageZoomProps } from './ImageZoom'
export { ImageZoom }
export type { ImageZoomProps }
